import { SlotStatus } from '@/models/vault'

interface StatusStyle {
  label: string
  /** The row's border. Status is carried by the outline, not by a fill. */
  box: string
  pill: string
  /** A bare number in this status's colour, for a tally. */
  text: string
}

const STYLES: Record<SlotStatus, StatusStyle> = {
  [SlotStatus.VALID]: {
    label: 'On file',
    // The same green edge and tint a complete folder has.
    box: 'border-green-700/40 bg-green-50/40',
    pill: 'bg-utility-success text-accent-green',
    text: 'text-accent-green',
  },
  [SlotStatus.EXPIRING_SOON]: {
    label: 'Expiring soon',
    box: 'border-amber-300',
    pill: 'bg-amber-100 text-amber-700',
    text: 'text-amber-700',
  },
  [SlotStatus.EXPIRED]: {
    label: 'Expired',
    box: 'border-red-300 bg-red-100',
    pill: 'bg-red-100 text-red-700',
    text: 'text-red-700',
  },
  [SlotStatus.MISSING]: {
    label: 'Not uploaded',
    // Dashed rather than solid: the whole row is the upload target.
    box: 'border-ink-300 border-dashed',
    pill: 'bg-gray-100 text-gray-600',
    text: 'text-gray-600',
  },
}

export function statusStyle(status: SlotStatus): StatusStyle {
  return STYLES[status] ?? STYLES[SlotStatus.MISSING]
}

/** What a folder's rollup says about the file underneath it. */
export function rollupLabel(status: SlotStatus): string {
  if (status === SlotStatus.VALID) return 'Complete'
  if (status === SlotStatus.EXPIRING_SOON) return 'Expiring soon'
  if (status === SlotStatus.EXPIRED) return 'Expired'
  return 'Incomplete'
}
